import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MeasureService } from './shared/measure.service';
import { MeasureComponent } from './measure.component';
import { MeasureToolboxComponent } from './measure-toolbox/measure-toolbox.component';
import { TranslateModule } from '@ngx-translate/core';
import { DragDropModule } from 'src/app/core/drag-drop/drag-drop.module';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        DragDropModule
    ],
    declarations: [
        MeasureComponent,
        MeasureToolboxComponent
    ],
    providers: [
        MeasureService
    ]
})
export class MeasureModule { }
